import React, { useContext } from "react";
import styled from "styled-components";
import { navigate } from "gatsby";
import {
  MenuTrigger,
  Menu,
  Item,
  ActionButton,
  Text,
  Section,
} from "@adobe/react-spectrum";
import ChevronDown from "@spectrum-icons/workflow/ChevronDown";
import Apps from "@spectrum-icons/workflow/Apps";
import { PluginContext } from "../contexts/PluginContext";

const PluginsHeaderMenu = styled.div`
  border-bottom: 2px solid var(--spectrum-global-color-gray-300);
  background-color: var(--spectrum-global-color-gray-75);
  z-index: 1;
  /* position: absolute; */
  position: fixed;
  width: 100%;
  height: 40px;
  padding-left: 30px;
  display: flex;
  align-items: center;
  @media only screen and (min-width: 900px) {
    margin-left: 256px;
    width: calc(100vw - 256px);
    height: 64px;
  }
`;

const PluginsHeader = () => {
  const pluginNames = {
    allPlugins: "All Plugins",
    alce: "ALCE",
    "double-usm": "Double USM",
    "floating-adjustments": "Floating Adjustments",
    "theme-switcher": "Theme Switcher",
  };

  const { activePlugin, setActivePlugin } = useContext(PluginContext);
  const toToPluginPage = selection => {
    setActivePlugin(selection.currentKey);
    if (selection.currentKey === "allPlugins") {
      // console.log("PluginsHeader", selection.currentKey);
      navigate("/plugins");
    } else {
      // console.log("PluginsHeader", selection.currentKey);
      navigate(`/plugins/${selection.currentKey}`);
    }
  };
  return (
    <PluginsHeaderMenu>
      <MenuTrigger>
        <ActionButton isQuiet>
          <ChevronDown />
          <Text>{pluginNames[activePlugin]}</Text>
        </ActionButton>
        <Menu
          // onAction={key => toToPluginPage(key)}
          selectionMode="single"
          disallowEmptySelection="false"
          selectedKeys={[activePlugin]}
          onSelectionChange={evt => toToPluginPage(evt)}
        >
          <Section title="Plugins">
            <Item key="allPlugins" textValue="All Plugins">
              <Text>All Plugins</Text>
              <Apps size="S" />
            </Item>
          </Section>
          <Section title="Image Processing">
            <Item key="alce" textValue="ALCE">
              <Text>ALCE</Text>
            </Item>
            <Item key="double-usm" textValue="Double USM">
              <Text>DUSM</Text>
            </Item>
          </Section>
          <Section title="Utilities">
            <Item key="theme-switcher" textValue="Theme Switcher">
              <Text>Theme Switcher</Text>
            </Item>
            <Item key="floating-adjustments" textValue="Floating Adjustments">
              <Text>Floating Adjustments</Text>
            </Item>
          </Section>
        </Menu>
      </MenuTrigger>
    </PluginsHeaderMenu>
  );
};

export default PluginsHeader;
